type IDetail = {
    scrollCenter: boolean
};
/**
 * 发出resize事件
 */
const dispatchResizeEvent = (detail: IDetail): void => {
    window.dispatchEvent(new CustomEvent('resize', {
        detail,
    }));
};
export {
    dispatchResizeEvent,
};
